import React from 'react';
import styles from '../search.module.css';

export default function HeroSection({ children }) {
  return (
    <div className={styles.heroSection}>
      <h1 className={styles.title}>Search Your Domain here</h1>
      <p className={styles.subtitle}>Search across your entire domain with powerful results</p>
      {children}
    </div>
  );
}
